import * as React from "react";
import { cn } from "@/lib/utils";

// The cyan radial glow from the design. Reserved for the dashboard, login and
// "klaar" screens — don't use it on regular pages.
export function HeroGlow({ className }: { className?: string }) {
  return (
    <div
      aria-hidden
      className={cn("pointer-events-none absolute -left-[12%] -right-[12%] -bottom-[20%] z-0 h-[40%]", className)}
      style={{
        background:
          "radial-gradient(50% 50% at 50% 50%, rgba(61,184,245,0.28) 0%, rgba(61,184,245,0.11) 44%, rgba(61,184,245,0) 74%)",
      }}
    />
  );
}

export function Hero({ className, children, glowClassName, ...props }: React.HTMLAttributes<HTMLDivElement> & { glowClassName?: string }) {
  return (
    <div
      className={cn("relative overflow-hidden rounded-card-lg bg-gradient-to-b from-white to-waves-subtle", className)}
      {...props}
    >
      <HeroGlow className={glowClassName} />
      <div className="relative z-[1]">{children}</div>
    </div>
  );
}
